import { useTokenContext } from 'contexts/resource/ResourceContext';

const useFormatNumber = () => {
  const { numberingFormat } = useTokenContext();

  const formatNumber = (
    data: string | number,
    isNotDecimalFormat?: boolean
  ): string => {
    const number = typeof data === 'string' ? Number(data) : data;
    const locale = numberingFormat === 'indian' ? 'en-IN' : 'en-US';
    let formattedNumber;
    if (isNotDecimalFormat) {
      formattedNumber = number?.toLocaleString(locale);
    } else {
      formattedNumber = number?.toLocaleString(locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    }

    return `${formattedNumber}`;
  };

  return formatNumber;
};

export default useFormatNumber;
